import { useEffect } from 'react'

// Right-side slide-over panel with a dark overlay (Zoho-style details panel).
export default function Drawer({ open, onClose, title, subtitle, t, width = 440, children, footer }) {
  useEffect(() => {
    function onEsc(e) { if (e.key === 'Escape') onClose && onClose() }
    if (open) document.addEventListener('keydown', onEsc)
    return () => document.removeEventListener('keydown', onEsc)
  }, [open, onClose])

  if (!open) return null

  return (
    <div className="eh-overlay" onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 1000, display: 'flex', justifyContent: 'flex-end' }}>
      <div className="eh-drawer" onClick={(e) => e.stopPropagation()}
        style={{ width, maxWidth: '92vw', height: '100%', background: t.card, boxShadow: '-10px 0 40px rgba(0,0,0,0.25)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '1.1rem 1.4rem', borderBottom: `1px solid ${t.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 17, fontWeight: 800, color: t.text }}>{title}</div>
            {subtitle && <div style={{ fontSize: 12, color: t.textMuted, marginTop: 2 }}>{subtitle}</div>}
          </div>
          <button onClick={onClose} aria-label="Close"
            style={{ background: t.input, border: `1px solid ${t.border}`, borderRadius: 8, width: 30, height: 30, cursor: 'pointer', color: t.textSub, fontSize: 15, flexShrink: 0 }}>✕</button>
        </div>
        <div style={{ padding: '1.4rem', overflowY: 'auto', flex: 1 }}>{children}</div>
        {footer && <div style={{ padding: '1rem 1.4rem', borderTop: `1px solid ${t.border}` }}>{footer}</div>}
      </div>
    </div>
  )
}
